var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[( !_setup.routeNavStatus && !['readBook','Home'].includes(_setup.routeName))?_c(_setup.Menu):_vm._e(),(_setup.routeNavStatus)?_c(_setup.Header):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }